import React, { useState, useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { Button, Col, FormFeedback, FormGroup, Input, Label, Modal, Row } from 'reactstrap';
import { updateQuotionAssingToData, updateQuotionStatusData } from '../../../../store/Sales/actions';
import { showErrorToast } from '../../../../components/Common/CustomToast';
import { INQUIRY_REJECTED, MANAGER_APPRVD, MANAGER_REJECT, REQUEST_FOR_RATE } from '../../../Dashboard/Partials/initialData';
import Select from "react-select";
import { UPDATE_SEARCH_INSTANT_RATE_DATA } from "../../../../store/InstantRate/actionType";
import { cube_filled } from "../../../../assets/images";
import { accessMarketPlaceRate } from "../../../../store/layout/actions";
import { wallet as selectedInquiry } from "../../../../common/data";
import AsyncSelect from 'react-select/async';
import debounce from 'lodash.debounce';
const AgentType = {
    REGISTERED_AGENTS: "REGISTERED_AGENTS",
    TARIFFTALES_NETWORK: "TARIFFTALES_NETWORK",
    BOTH: "BOTH",
};
const ApproveRejectPopUp = ({ isOpen, onClose, selectedRows, data, remark, seletedInquiry, disableRequestForrate }) => {
    if (!isOpen) return null;
    const { status_master } = useSelector(state => state?.globalReducer);
    const { instantInquiryId, incoterm } = useSelector((state) => state.instantRate);
    const { reason_master, commodity_data, currency_data } = useSelector(state => state?.globalReducer);
    const [agentType, setAgentType] = useState(AgentType.REGISTERED_AGENTS);

    const [remarks, setRemarks] = useState(remark);
    const dispatch = useDispatch();
    const [reason, setReason] = useState("")

    const [selectedTab, setSelectedTab] = useState('import');
    const [insurance, setInsurance] = useState(false);
    const [customClearance, setCustomClearance] = useState(false);
    const [originClearance, setOriginClearance] = useState(false);
    const [destinationClearance, setDestinationClearance] = useState(false);
    const [isShipper, setIsShipper] = useState(true);
    const [incoTerms, setIncoTerms] = useState('');
    const [filteredCount, setFilteredCount] = useState(0);
    const [commodityDataStore, setCommodityDataStore] = useState('');
    const [cargoValue, setCargoValue] = useState();
    const [currencyValue, setCurrencyValue] = useState({ value: 'US DOLLAR', label: 'USD', currencyCode: 'USD', id: 3, version: 0 });

    useEffect(() => {
        setFilteredCount(commodity_data.length);
    }, [commodity_data]);

    const handleChangeMovementType = (type) => {
        setIsShipper(type);
    }

    const handleChangeHandler = (value, name) => {
        //console.log(value);
        setIncoTerms(value);
    }

    const commodityOptions = useCallback(
        debounce((inputValue, callback) => {
            const filtered = commodity_data.filter(option => option.label.toLowerCase().includes(inputValue.toLowerCase()));
            callback(filtered);
        }, 300),
        [commodity_data]
    );

    const onClickSave = () => {
        if (data == "Reason For Reject Inquiry") {
            if (reason?.id) {
                let paload = {
                    statusId: status_master?.find(status => String(status?.statusCode) === INQUIRY_REJECTED).id,
                    reasonId: reason?.id,
                    inquiryId: seletedInquiry
                }
                dispatch(updateQuotionStatusData(paload))
                onClose();
            } else {
                showErrorToast('Please select reason');
            }
        } else {
            if (data == "Request For Rate") {
                let payload = {
                    statusId: status_master?.find(status => String(status?.statusCode) === REQUEST_FOR_RATE).id,
                    remarks: remarks ? remarks.trim() : '',
                    inquiryId: instantInquiryId,
                    movementType: isShipper ? 'EXPORT' : 'IMPORT',
                    incotermId: incoTerms?.value || '',
                    isInsuranceRequired: insurance,
                    isChaRequired: customClearance,
                    isCustomsAtOrigin: originClearance,
                    isCustomsAtDestination: destinationClearance,
                    cargoValue: cargoValue || 0,
                    commodityId: commodityDataStore?.id || '',
                    currencyCode: currencyValue?.currencyCode || '',
                    agentType:agentType,
                }
                disableRequestForrate();
                dispatch(updateQuotionStatusData(payload))
                onClose();
            } else if (data == 'Approve' || data == 'Reject') {
                let paload = {
                    remarks: remarks.trim(),
                    statusId: data == 'Approve' ? status_master?.find(status => String(status?.statusCode) === MANAGER_APPRVD).id : status_master?.find(status => String(status?.statusCode) === MANAGER_REJECT).id,
                    quotationsIds: selectedRows,
                    inquiryIds: seletedInquiry
                }
                dispatch(updateQuotionAssingToData(paload));
                onClose();
            }
        }
    };

    return (
        <Modal size={data === 'Request For Rate' ? 'lg' : 'md'} isOpen={isOpen} onClose={onClose} className={data === 'Request For Rate' ? '' : 'remarks'}>
            <div className="modal-header">
                <h4 className="m-0">{data}</h4>
                <button
                    onClick={onClose}
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                >
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div className="modal-body">
                {data === 'Request For Rate' &&
                    <>
                        <div className="p-1">
                            <Row className="mb-4 align-items-center">
                                <Col md={6}>
                                    <div className="toggle-container mb-1">
                                        <div
                                            className={`toggle-option ${isShipper ? 'active' : ''}`}
                                            onClick={() => handleChangeMovementType(true)}>
                                            Export
                                        </div>
                                        <div
                                            className={`toggle-option ${!isShipper ? 'active' : ''}`}
                                            onClick={() => handleChangeMovementType(false)}>
                                            Import
                                        </div>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className="charges_wrap">
                                        <label className="form-label">Incoterms</label>
                                        <div className='field_wrap'>
                                            <Select
                                                name='incoterms'
                                                value={incoTerms}
                                                onChange={(option) => handleChangeHandler(option, 'incoterms')}
                                                placeholder="Select Incoterms"
                                                options={incoterm || []}
                                                classNamePrefix="form-select"
                                                menuPlacement="auto"
                                            />
                                        </div>
                                    </div>
                                </Col>
                            </Row>

                            <Row className="mb-3">
                                <Col md={6}>
                                    <div className="charges_wrap">
                                        <label className="form-label">Commodity</label>
                                        <AsyncSelect
                                            id='commodity'
                                            name='commodity'
                                            cacheOptions
                                            defaultOptions
                                            loadOptions={commodityOptions}
                                            noOptionsMessage={() => `${filteredCount} commodity found`}
                                            value={commodityDataStore || null}
                                            onChange={(option) => setCommodityDataStore(option)}
                                            placeholder="Type to search commodity..."
                                        />
                                    </div>

                                </Col>
                                <Col md={6}>
                                    <label className="form-label">Cargo Value</label>
                                    <div className="input-group">
                                        {/* Input Field */}
                                        <Input
                                            type="number"
                                            value={cargoValue}
                                            name="cargo_value"
                                            id="cargo_value"
                                            placeholder="Enter amount"
                                            onChange={(e) => setCargoValue(e.target.value)}
                                            className="form-control"
                                            style={{
                                                borderTopRightRadius: 0,
                                                borderBottomRightRadius: 0,
                                                borderRight: '0', // remove right border so it doesn't overlap with select
                                                boxShadow: 'none'
                                            }}
                                        />

                                        {/* Select Dropdown */}
                                        <div className="input-group-text p-0" style={{ width: '50%', padding: 0 }}>
                                            <Select
                                                className="w-100"
                                                classNamePrefix="select"
                                                options={currency_data}
                                                value={currency_data?.find(obj => obj.currencyCode === currencyValue?.currencyCode) || ''}
                                                onChange={(selectedOption) => setCurrencyValue(selectedOption)}
                                                isSearchable={false}
                                                styles={{
                                                    control: (provided, state) => ({
                                                        ...provided,
                                                        borderTopLeftRadius: 0,
                                                        borderBottomLeftRadius: 0,
                                                        borderLeft: '1px solid #ced4da',
                                                        borderTopRightRadius: '0.375rem',
                                                        borderBottomRightRadius: '0.375rem',
                                                        boxShadow: 'none',
                                                        minHeight: '38px',
                                                        height: '38px',
                                                        marginTop: '-1px',
                                                        borderColor: '#ced4da',
                                                        '&:hover': {
                                                            borderColor: '#ced4da'
                                                        }
                                                    }),
                                                    valueContainer: (provided) => ({
                                                        ...provided,
                                                        padding: '0 8px'
                                                    }),
                                                    indicatorsContainer: (provided) => ({
                                                        ...provided,
                                                        height: '38px'
                                                    }),
                                                    menu: (provided) => ({
                                                        ...provided,
                                                        zIndex: 9999,
                                                        borderRadius: '0.375rem',
                                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.05)',
                                                        marginTop: 2
                                                    }),
                                                    menuList: (provided) => ({
                                                        ...provided,
                                                        maxHeight: '200px',
                                                        overflowY: 'auto',
                                                        paddingTop: 0,
                                                        paddingBottom: 0
                                                    }),
                                                    option: (provided, state) => ({
                                                        ...provided,
                                                        textAlign: 'left',
                                                        paddingLeft: '12px',
                                                        backgroundColor: state.isSelected
                                                            ? '#e6f0ff'
                                                            : state.isFocused
                                                                ? '#f1f1f1'
                                                                : 'white',
                                                        color: '#000'
                                                    })
                                                }}
                                            />
                                        </div>
                                    </div>
                                </Col>
                            </Row>

                            <Row className="mb-3 align-items-center">
                                <Col xs="4" className="d-flex align-items-center gap-2 justify-content-start">
                                    <div className="d-flex align-items-center">
                                        <div className="square-switch mt-3">
                                            <Input type="checkbox"
                                                id="square-switch1"
                                                switch="none"
                                                role="switch"
                                                checked={originClearance}
                                                onClick={() => {
                                                    setOriginClearance(!originClearance)
                                                }}
                                            />
                                            <Label htmlFor="square-switch1" data-on-label="Yes"
                                                data-off-label="No"></Label>
                                        </div>
                                        <label className="form-label mb-0 ms-2" style={{ fontSize: '12px' }}>
                                            Origin Clearance
                                        </label>
                                    </div>
                                </Col>
                                <Col xs="4" className="d-flex align-items-center gap-2 justify-content-start">
                                    <div className="d-flex align-items-center">
                                        <div className="square-switch mt-3">
                                            <Input type="checkbox"
                                                id="square-switch3"
                                                switch="none"
                                                role="switch"
                                                checked={destinationClearance}
                                                onClick={() => {
                                                    setDestinationClearance(!destinationClearance)
                                                }}
                                            />
                                            <Label htmlFor="square-switch3" data-on-label="Yes"
                                                data-off-label="No"></Label>
                                        </div>
                                        <label className="form-label mb-0 ms-2" style={{ fontSize: '12px' }}>
                                            Destination Clearance
                                        </label>
                                    </div>
                                </Col>
                                <Col xs="4">
                                    <div className="d-flex align-items-center">
                                        <div className="square-switch mt-3">
                                            <Input
                                                type="checkbox"
                                                id="square-switch2"
                                                switch="none"
                                                role="switch"
                                                checked={insurance || false}
                                                onClick={() => {
                                                    setInsurance(!insurance);
                                                }}
                                            />
                                            <Label htmlFor="square-switch2" data-on-label="Yes" data-off-label="No"></Label>
                                        </div>
                                        <label className="form-label mb-0 ms-2" style={{ fontSize: '12px' }}>
                                            Insurance
                                        </label>
                                    </div>
                                </Col>
                            </Row>

                            <Row className="mb-3">
                                <Col>
                                    <Input
                                        type="textarea"
                                        rows="6"
                                        placeholder="Special Instructions"
                                        value={remarks}
                                        onChange={(e) => setRemarks(e.target.value)}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <div className="d-flex gap-2">
                                        <div
                                            className={`btn btn-outline-primary ${agentType === AgentType.REGISTERED_AGENTS ? "active" : ""
                                                }`}
                                            onClick={() => setAgentType(AgentType.REGISTERED_AGENTS)}
                                        >
                                            Registered Agents
                                        </div>

                                        <div
                                            className={`btn btn-outline-primary ${agentType === AgentType.TARIFFTALES_NETWORK ? "active" : ""
                                                }`}
                                            onClick={() => setAgentType(AgentType.TARIFFTALES_NETWORK)}
                                        >
                                            Tarifftales Network
                                        </div>

                                        <div
                                            className={`btn btn-outline-primary ${agentType === AgentType.BOTH ? "active" : ""
                                                }`}
                                            onClick={() => setAgentType(AgentType.BOTH)}
                                        >
                                            Both
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </>
                }
                {/*{data != "Reason For Reject Inquiry" && <textarea*/}
                {/*    className="form-control"*/}
                {/*    rows="4"*/}
                {/*    placeholder="Enter remarks here..."*/}
                {/*    value={remarks}*/}
                {/*    onChange={(e) => setRemarks(e.target.value)}*/}
                {/*/>}*/}
                {data === "Reason For Reject Inquiry" &&
                    <div>
                        <label>Reason</label>
                        <Select
                            name="reason"
                            options={reason_master}
                            value={reason}
                            onChange={(reason) => setReason(reason)}
                            classNamePrefix="select2-selection form-select"
                        />
                    </div>}
            </div>
            {data != "View Remarks" && <div className="modal-footer">
                <div className="btn_wrap d-flex mt-auto gap-2">
                    <button className="btn border" type="button" onClick={onClose}>
                        Cancel
                    </button>
                    <button className="btn btn-primary" type="button" onClick={onClickSave}>
                        Save
                    </button>
                </div>
            </div>}
        </Modal>
    );
};

export default ApproveRejectPopUp;
